export const allClass = [
  {
      titleClass: 'title-project',
      txtClass: 'txt-project',
      contentClass: 'box-project'
  },
  {
      titleClass: 'title-distance-bts-mrt',
      txtClass: 'txt-distance-bts-mrt',
      contentClass: 'box-distance-bts-mrt'
  },
  {
      titleClass: 'title-station',
      txtClass: 'txt-station',
      contentClass: 'box-station'
  },
  {
      titleClass: 'title-floor',
      txtClass: 'txt-floor',
      contentClass: 'box-floor'
  },
  {
      titleClass: 'title-total-units',
      txtClass: 'txt-total-units',
      contentClass: 'box-total-units'
  },
  {
      titleClass: 'title-parking-lot',
      txtClass: 'txt-parking-lot',
      contentClass: 'box-parking-lot'
  },
  {
      titleClass: 'title-launch-year',
      txtClass: 'txt-launch-year',
      contentClass: 'box-launch-year'
  },
  {
      titleClass: 'title-completed-year',
      txtClass: 'txt-completed-year',
      contentClass: 'box-completed-year'
  },
//   {
//       titleClass: 'title-package-price',
//       txtClass: 'txt-package-price',
//       contentClass: 'box-package-price'
//   },
//   {
//       titleClass: 'title-price-sqm',
//       txtClass: 'txt-price-sqm',
//       contentClass: 'box-price-sqm'
//   },
  {
      titleClass: 'title-resale-price',
      txtClass: 'txt-resale-price',
      contentClass: 'box-resale-price'
  },
  {
    titleClass: 'title-resale-package',
    txtClass: 'txt-resale-package',
    contentClass: 'box-resale-package'
  },
  {
    titleClass: 'title-rental-package',
    txtClass: 'txt-rental-package',
    contentClass: 'box-rental-package'
  },
  {
    titleClass: 'title-rental-price',
    txtClass: 'txt-rental-price',
    contentClass: 'box-rental-price'
  },
  {
      titleClass: 'title-slod-admin',
      txtClass: 'txt-slod-admin',
      contentClass: 'box-slod-admin'
  },
  {
      titleClass: 'title-units-left-admin',
      txtClass: 'txt-units-left-admin',
      contentClass: 'box-units-left-admin'
  },
  {
      titleClass: 'title-funiture',
      txtClass: 'txt-funiture',
      contentClass: 'box-funiture'
  },
  {
      titleClass: 'title-unittype',
      txtClass: 'txt-unittype',
      contentClass: 'box-unittype'
  },
  {
      titleClass: 'title-ceilling',
      txtClass: 'txt-ceilling',
      contentClass: 'box-ceilling'
  },
  {
      titleClass: 'title-facility',
      txtClass: 'txt-facility',
      contentClass: 'box-facility'
  },
  {
      titleClass: 'title-slinking-fund',
      txtClass: 'txt-slinking-fund',
      contentClass: 'box-slinking-fund'
  },
  {
      titleClass: 'title-common-fee',
      txtClass: 'txt-common-fee',
      contentClass: 'box-common-fee'
  }
];



// WEBPACK FOOTER //
// ./src/screens/CompareProject/variables.js